import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class UserApi extends Requestor {
    getUserMe(params = {}) {
        return this.get({
            url: '/api/v1/users/me',
            params,
        });
    }
    postUserIdExistence(data = {}) {
        return this.post({
            url: '/api/v1/users/id/existence',
            data,
        });
    }
    // 사용자 관리 - 리스트 조회
    getUserList(params = {}) {
        return this.get({
            url: '/api/v1/users',
            params,
        });
    }
    // 시용자 관리 - 조회/수정/등록
    getUser(userId, params = {}) {
        return this.get({
            url: `/api/v1/users/${userId}`,
            params,
        });
    }
    postUser(data = {}) {
        return this.post({
            url: '/api/v1/users',
            data,
        });
    }
    putUser(userId, data = {}) {
        return this.put({
            url: `/api/v1/users/${userId}`,
            data,
        });
    }
    getUserMenuAuthority(userId) {
        return this.get({
            url: `/api/v1/users/${userId}/menu-authority`,
        });
    }
    putUserMenuAuthority(userId, data) {
        return this.put({
            url: `/api/v1/users/${userId}/menu-authority`,
            data,
        });
    }
}
export default new UserApi(clientInstance);
